"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Tag = {
  defaultProps: {
    size: "small",
    color: "baseContrast020"
  },
  styles: function styles(theme) {
    return {
      root: {
        fontWeight: 400,
        borderRadius: 24,
        padding: [Math.floor(theme.spacing.base / 4), theme.spacing.base]
      },
      compact: {
        fontSize: theme.typography.fontSize,
        fontWeight: 400
      },
      compactIcon: {
        paddingInlineEnd: 0,
        "& svg": {
          width: 18,
          height: 18,
          minHeight: 18,
          minWidth: 18
        }
      },
      border: {
        padding: [Math.floor(theme.spacing.base / 4), theme.spacing.base, Math.floor(theme.spacing.base / 4) - 2]
      }
    };
  }
};
var _default = exports.default = Tag;